<template>
  <div id="contents">
    <div class="inner">
      <h3 class="main-title">회사연혁</h3>
      <ul class="tab-wrap">
        <li><a href="/intro" class="tab-btn">회사 소개</a></li>
        <li><a href="/history" class="tab-btn active">회사 연혁</a></li>
      </ul>
    </div>
    <section class="history-wrap">
      <article class="company-history">
        <div class="inner">
          <ul class="history-list">
            <li>
              <span class="year">2024</span>
              <ul class="desc">
                <li>SK브로드밴드 B TV 우리동네광고 공식대행사 체결</li>
                <li>KT skylife(스카이라이프) IPTV 광고 공식대행사 체결</li>
              </ul>
            </li>
            <li>
              <span class="year">2022</span>
              <ul class="desc">
                <li>누적계약 2000건 달성</li>
              </ul>
            </li>
            <li>
              <span class="year">2021</span>
              <ul class="desc">
                <li>재계약률 30%달성</li>
              </ul>
            </li>
            <li>
              <span class="year">2020</span>
              <ul class="desc">
                <li>누적계약 1000건 돌파</li>
              </ul>
            </li>
            <li>
              <span class="year">2019</span>
              <ul class="desc">
                <li>디지털 마케팅 네크워크 구축</li>
                <li>누적계약 500건 돌파</li>
                <li>온라인 비즈니스 솔루션 개발 및 인프라 구축</li>
              </ul>
            </li>
            <li>
              <span class="year">2018</span>
              <ul class="desc">
                <li>애드매스 가산본사 설립</li>
              </ul>
            </li>
          </ul>
        </div>
      </article>
    </section>
  </div>
</template>
<script>

export default {
  name: 'page-notice',
  components: {

  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },

  data () {
    return {
      curWidth: 2.5
    }
  },

  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("article").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>